export default __webpack_public_path__ + "static/media/warning--roadworks--g10.1e4a14ca.png";